import React from "react";

const SvgClose = props => (
  <svg width={100} height={100} viewBox="0 0 512 512" {...props}>
    <path d="M505.9 6.1c-8.1-8.1-21.2-8.1-29.2 0L6.1 476.7c-8.1 8.1-8.1 21.2 0 29.2 4 4 9.3 6.1 14.6 6.1s10.6-2 14.6-6.1L505.9 35.3c8.1-8.1 8.1-21.2 0-29.2z" />
    <path d="M505.9 476.7L35.3 6.1C27.2-2 14.1-2 6.1 6.1c-8.1 8-8.1 21.1 0 29.2l470.6 470.6c4 4 9.3 6.1 14.6 6.1s10.6-2 14.6-6.1c8.1-8 8.1-21.1 0-29.2z" />
  </svg>
);

export default SvgClose;
